<template>
  <div>
    <Head title="Create Logistic" />
    <h1 class="mb-8 text-3xl font-bold">
      Transaksi
      <span class="text-indigo-400 font-medium"> / </span>
      <Link class="text-indigo-400 hover:text-indigo-600" href="/logistics">
        Donasi Logistic
      </Link>
      <span class="text-indigo-400 font-medium"> / </span> Create
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input
            v-model="form.activity"
            :error="form.errors.activity"
            class="pb-8 pr-6 w-full"
            label="Kegiatan" />
          <select-input
            v-model="form.organization_id"
            :error="form.errors.organization_id"
            class="pb-8 pr-6 w-full md:w-1/2"
            label="Donatur">
            <option
              v-for="organization in organizations"
              :key="organization.id"
              :value="organization.id">
              {{ organization.name }}
            </option>
          </select-input>
          <div class="pb-8 pr-6 flex flex-col w-full md:w-1/2">
            <label for="date">Tanggal:</label>
            <flat-pickr
              v-model="form.trans_date"
              class="p-2 w-full border rounded mt-2"
              name="date" />
            <div v-if="form.errors.trans_date" class="form-error">
              {{ form.errors.trans_date }}
            </div>
          </div>
          <textarea-input
            v-model="form.description"
            :error="form.errors.description"
            class="pb-8 pr-6 w-full md:w-2/3"
            label="Keterangan" />
          <div class="w-full" />
          <text-input
            v-model="form.signature01"
            :error="form.errors.signature01"
            class="pb-8 pr-6 w-full md:w-1/3"
            label="Mengetahui" />
          <text-input
            v-model="form.signature02"
            :error="form.errors.signature02"
            class="pb-8 pr-6 w-full md:w-1/3"
            label="Penerima" />
          <text-input
            v-model="form.signature03"
            :error="form.errors.signature03"
            class="pb-8 pr-6 w-full md:w-1/3"
            label="Pengirim" />
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button
            :loading="form.processing"
            class="btn-indigo"
            type="submit">
            Create Logistic
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script lang="js">
import { Head, Link } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextareaInput from '@/Shared/TextareaInput'
import TextInput from '@/Shared/TextInput'
import flatPickr from 'vue-flatpickr-component'
import { format } from 'date-fns'
import 'flatpickr/dist/flatpickr.css'

export default {
    components: {
        Head,
        Link,
        LoadingButton,
        SelectInput,
        TextareaInput,
        TextInput,
        flatPickr,
    },
    layout: Layout,
    props: {
        organizations: Object,
    },
    remember: 'form',
    data () {
        return {
            form: this.$inertia.form({
                organization_id: null,
                trans_date: format(new Date(), 'yyyy-MM-dd'),
                description: null,
                activity: null,
                signature01: null,
                signature02: null,
                signature03: null,
            }),
        }
    },
    methods: {
        store () {
            this.form.post('/logistics')
        },
    },
}
</script>
